module.exports = __webpack_public_path__ + "static/assets/2b19d20d386219bd4e0cf4d899cb3ca9.gif";